import { isThreadEmbedLocation } from "./studyEmbedBridge";

/**
 * True when this document is the study pane iframe (`?embed=thread`).
 *
 * Reads the address bar rather than the router so a page rendered without
 * one (and tests that stub navigation) stay on the non-embed path.
 */
export function useEmbedMode(): boolean {
  return isThreadEmbedLocation();
}
